import React from 'react';
import styled from 'styled-components';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const CenteredContainer = styled.div`
  height: 100%;
  min-height: 10vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Spinner = ({ className = 'spinner', size = 2 }) => (
  <CenteredContainer data-testid="spinner" className={className}>
    <Spin
      indicator={
        <LoadingOutlined
          spin
          style={{
            fontSize: `${size}rem`,
            color: `${({ theme }) => theme.blue}`,
          }}
        />
      }
    />
  </CenteredContainer>
);
